import { createSelector } from "reselect";
import { isValid } from "date-fns";
import { getMerchPreviewStartDate } from "app/pages/Merchandising/merchandisingSelector";
import { formatPreviewDateToUTCDate, isBetweenDates } from "app/utils/utils";

export const getPushNotifs = state =>
	state.pushNotification && state.pushNotification.pushNotifications;

const isPushNotificationExpired = (pushNotification, previewDateTimestamp) => {
	const todayTimestamp = new Date().getTime();
	const pushNotificationEndAtTimestamp = new Date(pushNotification.endAt).getTime();
	const pushNotificationStartAtTimestamp = new Date(pushNotification.launchAt).getTime();
	if (isValid(previewDateTimestamp)) {
		return !(
			previewDateTimestamp >= pushNotificationEndAtTimestamp ||
			previewDateTimestamp < pushNotificationStartAtTimestamp
		);
	}

	// do not return expired push notification
	return pushNotificationEndAtTimestamp >= todayTimestamp;
};

export const getPushNotifications = createSelector(
	[getPushNotifs, getMerchPreviewStartDate],
	(pushNotifications = [], previewStartDate) => {
		// Déterminer la date de référence à utiliser (prévisualisation ou date actuelle)
		const referenceDate = previewStartDate
			? formatPreviewDateToUTCDate(previewStartDate)
			: new Date();

		// Appliquer la fonction de filtrage appropriée selon la présence d'une date de prévisualisation
		return [...pushNotifications].filter(notification =>
			previewStartDate
				? isPushNotificationExpired(notification, referenceDate)
				: isBetweenDates(notification.launchAt, notification.endAt)
		);
	}
);
